import CastFigure from '../../motion/CastFigure';
import { castKey, hasPose } from '../../data/cast';
import { FolioSection, SectionMast } from '../home/HomeEditorial';
import { formatRegistrarNumber } from './RegistrarNumber';

function managerForTeam(teams, fantasyTeam) {
  return teams.find((team) => team.team === fantasyTeam)?.manager;
}

function poseFor(manager, preferred, fallback = 'base') {
  const key = castKey(manager);
  return hasPose(key, preferred) ? preferred : fallback;
}

function ExhibitTile({ tile }) {
  return (
    <article className={`rg-exhibit rg-exhibit--${tile.tone} ${tile.hero ? 'rg-exhibit--hero' : ''}`}>
      <div className="rg-exhibit__copy">
        <span>{tile.label}</span>
        <strong className={tile.emphasis ? 'rg-exhibit__value--max' : ''}>{tile.value}</strong>
        <h3>{tile.headline}</h3>
        <p>{tile.detail}</p>
        {tile.verified && <small className="rg-exhibit__verification">Verified under both sources</small>}
      </div>
      <CastFigure name={tile.manager} pose={tile.pose} trigger="none" preload={false} className="rg-exhibit__figure" alt={`${tile.manager} caricature`} />
    </article>
  );
}

export default function RegistrarExhibits({ superlatives, teams }) {
  const stealManager = managerForTeam(teams, superlatives.stealOfDraft.fantasyTeam);
  const reachManager = managerForTeam(teams, superlatives.biggestReach.fantasyTeam);
  const bestKeeperManager = managerForTeam(teams, superlatives.bestKeeperDeal.fantasyTeam);
  const worstKeeperManager = managerForTeam(teams, superlatives.worstKeeperDeal.fantasyTeam);
  const tiles = [
    {
      label: 'Steal of the draft',
      value: formatRegistrarNumber(superlatives.stealOfDraft.valueVsSlot, { precision: 1, signed: true }),
      headline: superlatives.stealOfDraft.player,
      detail: `${stealManager} · Round ${superlatives.stealOfDraft.round}`,
      manager: stealManager,
      pose: poseFor(stealManager, 'shock'),
      tone: 'gold',
      hero: true,
      verified: true,
    },
    {
      label: 'Biggest reach',
      value: formatRegistrarNumber(superlatives.biggestReach.valueVsSlot, { precision: 1, signed: true }),
      headline: superlatives.biggestReach.player,
      detail: `${reachManager} · Round ${superlatives.biggestReach.round}`,
      manager: reachManager,
      pose: poseFor(reachManager, 'facepalm'),
      tone: 'crimson',
      hero: true,
      emphasis: true,
      verified: true,
    },
    {
      label: 'Best keeper',
      value: formatRegistrarNumber(superlatives.bestKeeperDeal.keeperSurplus, { precision: 1, signed: true }),
      headline: superlatives.bestKeeperDeal.player,
      detail: `${bestKeeperManager} · Filed. It did not save him.`,
      manager: bestKeeperManager,
      pose: poseFor(bestKeeperManager, 'celebrate'),
      tone: 'dark',
    },
    {
      label: 'Worst keeper',
      value: formatRegistrarNumber(superlatives.worstKeeperDeal.keeperSurplus, { precision: 1, signed: true }),
      headline: superlatives.worstKeeperDeal.player,
      detail: worstKeeperManager,
      manager: worstKeeperManager,
      pose: poseFor(worstKeeperManager, 'facepalm'),
      tone: 'cream',
    },
    {
      label: 'Strongest late-round haul',
      value: formatRegistrarNumber(superlatives.strongestLateRoundHaul.lateValueVsSlot, { precision: 1, signed: true }),
      headline: superlatives.strongestLateRoundHaul.manager,
      detail: `${superlatives.strongestLateRoundHaul.team} · rounds 12–17`,
      manager: superlatives.strongestLateRoundHaul.manager,
      pose: poseFor(superlatives.strongestLateRoundHaul.manager, 'point'),
      tone: 'dark',
    },
    {
      label: 'Thinnest margin',
      value: formatRegistrarNumber(superlatives.thinnestMargin.riskScore, { precision: 1 }),
      headline: superlatives.thinnestMargin.manager,
      detail: superlatives.thinnestMargin.team,
      manager: superlatives.thinnestMargin.manager,
      pose: poseFor(superlatives.thinnestMargin.manager, 'sweat', 'shock'),
      tone: 'dark',
    },
  ];

  return (
    <FolioSection numeral="03" className="rg-exhibits border-b border-border bg-bg-base">
      <SectionMast tag="The exhibits" title="Six Findings." color="crimson" />
      <div className="rg-exhibits__grid" data-testid="registrar-superlatives">
        {tiles.map((tile) => <ExhibitTile key={tile.label} tile={tile} />)}
      </div>
    </FolioSection>
  );
}
